import { AccountContext } from 'components/AccountContext';
import ChildHeader from 'components/Dashboard/Main/ChildHeader';
import React, { useContext, useRef } from 'react';
import {
  VStack,
  useDisclosure,
  chakra,
  Center,
  HStack,
  Flex,
  Heading,
  Spacer,
  Image,
  ButtonGroup,
  Button,
  Box,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
} from '@chakra-ui/react';

import { useNavigate } from 'react-router-dom';
import PetCadastrado from '../../../../images/petCadastrado.svg';
function SucessoCadastroPet() {
  const { setPage, setUser, user } = useContext(AccountContext);
  setPage('Cadastro Pet');
  const { isOpen, onOpen, onClose } = useDisclosure();
  const finalRef = useRef(null);
  const navigate = useNavigate();

  return (
    <>
      <ChildHeader />
      <Flex minW="210px" maxW="340px" mx="auto" overflow="hidden" p={5}>
        <VStack align="stretch" spacing={6} w="100%" mt="6em">
          <VStack bg="#F3F3F3" borderRadius="0.8em" p={6} spacing={4} align="flex-start" w="100%">
            <Image boxSize="4em" objectFit="contain" src={PetCadastrado} alt="" />

            <Heading fontSize="20px" color="#5AB2AE" textAlign="left" wordBreak="break-word">
              O novo Pet foi adicionado com sucesso!
            </Heading>
          </VStack>

          <Flex minH={{ base: '35vh', md: '45vh' }} flexDirection="column">
            <VStack w="100%" align="stretch" bg="white" mt="50%">
              <Button color="white" bg="#5AB2AE" h="2.5em" onClick={() => navigate('/perfil/assinaturas')}>
                Visualizar Pet
              </Button>
            </VStack>
          </Flex>
        </VStack>
      </Flex>
    </>
  );
}

export default SucessoCadastroPet;
